import type { OnlineShareChannel } from 'src/app/pages/starterDashboardV2/shared/types';
import type { ShareAction, ShareChannel } from 'src/app/shared/hooks/share';
import { useAvailableShareActions } from 'src/app/shared/hooks/share';

import { useDashboardShareChannels } from './useDashboardShareChannels';
import { useDashboardShareOptions } from './useDashboardShareOptions';

type OnlineShareAction = ShareAction<OnlineShareChannel>;

/**
 * Minimal post type that contains only the fields actually used by share actions.
 * Only requires: id (for tracking) and platform (for channel matching).
 */
export type ShareablePost = {
	readonly id: string;
	readonly platform: string;
};

export function useDashboardShareActions(
	channel?: OnlineShareChannel,
	previewLinkConfigs?: readonly ShareablePost[],
	customTrackingData?: Array<Record<string, string>>,
	customUtmParams?: Array<Record<string, string>>,
): readonly OnlineShareAction[] {
	const options = useDashboardShareOptions(previewLinkConfigs, customTrackingData, customUtmParams);
	const channels = useDashboardShareChannels();
	return useAvailableShareActions(channel ? [channel] : channels, options);
}

export type DashboardShareAction = ShareAction<ShareChannel>;
